import React from "react";
import "./About-banner.css";
import { Link } from "react-router-dom";

const About_banner = () => {
  return (
    <>
      <section className='about-banner-sec'>
        <div className='container'>
          <div className='banner-div'>
            <img className='abt-banner' src={process.env.PUBLIC_URL + '/assets/images/about-us/banner/banner2.png'} alt="about-banner" />

            <div className="downloadbtnsec">
              <Link to="https://play.google.com/store/apps/details?id=com.loconex.app" target="_blank">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/googleplay.png"
                  }
                  alt="google-play"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About_banner;
